export const REVERT_SNAPSHOT = "REVERT_SNAPSHOT";
export const DELETE_SNAPSHOT = "DELETE_SNAPSHOT";

export const SNAPSHOT_MODAL_LIST = Object.freeze([REVERT_SNAPSHOT, DELETE_SNAPSHOT]);
